import { ScrollToTop } from './components/ScrollToTop'
import './App.css'
// core styles
import "./scss/volt.scss";
import HomeRoute from './Routes/HomeRoute';
import { useEffect } from 'react';
function App() {
  useEffect(() => {
    localStorage.removeItem('activeMenu');
  }, []);
  return (
    <>
      <ScrollToTop />
      <HomeRoute/> 
    </>
  )
}

export default App
